import { createContext, useContext, type ReactNode } from 'react'
import type { IChartApi } from 'lightweight-charts'
import type { ISeriesApi } from 'lightweight-charts'

interface ChartApiContextValue {
  chart: IChartApi | null
  series: ISeriesApi<'Candlestick'> | ISeriesApi<'Line'> | null
  lastCandleTime: number | null
}

const ChartApiContext = createContext<ChartApiContextValue>({ chart: null, series: null, lastCandleTime: null })

export function ChartApiProvider({
  value,
  children,
}: {
  value: ChartApiContextValue
  children: ReactNode
}) {
  return <ChartApiContext.Provider value={value}>{children}</ChartApiContext.Provider>
}

export function useChartApi() {
  return useContext(ChartApiContext)
}
